import React from 'react';
import { withSvg } from '../Svg';

const SvgTikTok = () => (
  <path
    d="M10.442 0.016C11.534 0 12.616 0.008 13.7 0c0.066 1.275 0.525 2.575 1.458 3.475 0.934 0.925 2.25 1.35 3.534 1.492v3.358c-1.2 -0.042 -2.408 -0.292 -3.5 -0.808 -0.475 -0.216 -0.916 -0.492 -1.35 -0.775 -0.008 2.434 0.008 4.866 -0.016 7.292a6.364 6.364 0 0 1 -1.125 3.284c-1.092 1.6 -2.984 2.642 -4.925 2.675 -1.192 0.066 -2.384 -0.258 -3.4 -0.858 -1.684 -0.992 -2.866 -2.808 -3.042 -4.758a15.455 15.455 0 0 1 -0.008 -1.242 6.255 6.255 0 0 1 2.15 -4.134c1.384 -1.2 3.316 -1.775 5.125 -1.434 0.016 1.234 -0.034 2.466 -0.034 3.7 -0.825 -0.266 -1.792 -0.192 -2.516 0.308a2.891 2.891 0 0 0 -1.134 1.458c-0.175 0.425 -0.125 0.892 -0.116 1.342 0.2 1.366 1.516 2.516 2.916 2.392 0.934 -0.008 1.825 -0.55 2.308 -1.342 0.158 -0.275 0.334 -0.558 0.342 -0.884 0.084 -1.492 0.05 -2.975 0.058 -4.466 0.008 -3.358 -0.008 -6.708 0.016 -10.058"
    fill="white"
  />
);

export default withSvg(22, 22)(SvgTikTok);
